import {Pagination} from "@mui/material";
import EmptyPagination from "@ui/paginationCustom/EmptyPagination";
import React from "react";
import {useMedia} from "@hooks/ui/useMedia";
import {SxType} from "@baseTypes/sx/sxTypes";
import HelperResetPage from "@ui/paginationCustom/HelperResetPage";

const sx: SxType = {
    '& .MuiPagination-ul': {
        rowGap: '3px',
    },
    '& .MuiPaginationItem-root ': {
        '.lightTheme &': {
            backgroundColor: '#fff',
            '&.Mui-selected':{
                backgroundColor: 'black',
                color:'white',
            }
        },
        '.darkTheme &': {
            backgroundColor: '#121212',
            '&.Mui-selected':{
                backgroundColor: 'white',
                color:'black',
            }
        },

    },
}

interface IProps {
    page: number,
    totalPage: number,
    onChange: (page: number) => void,
    empty?: boolean,
    disabled?: boolean,
    boundaryCount?: number,
    sx?: SxType,
    size?: 'small' | 'medium' | 'large'
}

const PaginationCustom = ({
                              page,
                              totalPage,
                              onChange,
                              empty = false,
                              disabled = false,
                              boundaryCount,
                              sx: sxProps = {},
                              size,
                          }: IProps) => {

    const {isDesktop} = useMedia()
    const handleChange = (_: any, value: number) => {
        onChange(value)
    }

    if (empty) {
        return (
            <EmptyPagination
                page={page}
                setPage={onChange}
                disabled={disabled}
                totalPage={totalPage}
            />
        )
    }
    return (
        <>
            {(totalPage < page && page > 1) && <HelperResetPage
                onChangePage={onChange}
                page={page}
                totalPage={totalPage}
            />}
            <Pagination
                sx={sxProps ? {
                    ...sx,
                    ...sxProps
                } : sx}
                count={totalPage}
                page={page}
                onChange={handleChange}
                variant="outlined"
                size={size}
                shape="rounded"
                boundaryCount={boundaryCount || boundaryCount === 0 ? boundaryCount : (isDesktop ? 2 : 1)}
                hideNextButton={!isDesktop}
                hidePrevButton={!isDesktop}
            />
        </>
    );
};

export default PaginationCustom;